import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { registerPageAccess } from "../api/logAcesso";
import { useAuth } from "../context/AuthContext";
import { logAcessoBaseURL } from "../variables";

const DEFAULT_PUBLIC_PATHS = ["/", "/painel-central"];

type PageAccessTrackerProps = {
  publicPaths?: string[];
};

function buildPagina(pathname: string, search: string): string {
  return search ? `${pathname}${search}` : pathname;
}

export function PageAccessTracker({ publicPaths = DEFAULT_PUBLIC_PATHS }: PageAccessTrackerProps) {
  const location = useLocation();
  const { user, isInitialized, getAccessToken } = useAuth();
  const lastPaginaRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user) {
      lastPaginaRef.current = null;
    }
  }, [user]);

  useEffect(() => {
    if (!logAcessoBaseURL || !isInitialized || !user) return;

    const pagina = buildPagina(location.pathname, location.search);
    if (publicPaths.includes(location.pathname)) return;
    if (lastPaginaRef.current === pagina) return;

    lastPaginaRef.current = pagina;
    void (async () => {
      const token = await getAccessToken();
      if (!token) return;
      await registerPageAccess({ pagina, token });
    })().catch(() => undefined);
  }, [
    getAccessToken,
    isInitialized,
    location.pathname,
    location.search,
    publicPaths,
    user,
  ]);

  return null;
}
